// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Batch inward check clearing and validation'"></sub-header>

<div class="tab-menu">
  <ul class="nav-tabs">
    <li ng-class="{'active': \$ctrl.displayMode === 'CHECKS'}">
      <a data-target="#tab-clearing" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('CHECKS')">
        <span>Checks</span>
      </a>
    </li>

    <li ng-class="{'active': \$ctrl.displayMode === 'CLEARING_RESULT'}">
      <a data-target="#tab-history" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('CLEARING_RESULT')">
        <span>Clearing results</span>
      </a>
    </li>

    <li ng-class="{'active': \$ctrl.displayMode === 'DISPOSITIONS'}" permissions='CHK_OUTGOING_DISPOSITION_READ'>
      <a data-target="#tab-disposition" data-toggle="tab" ng-click="\$ctrl.setDisplayMode('DISPOSITIONS')">
        <span>Disposition</span>
      </a>
    </li>
  </ul>
</div>

<div class="tab-content">
  <div id="tab-clearing">
    <batch-clearing ng-if="\$ctrl.displayMode === 'CHECKS'"></batch-clearing>
  </div>

  <div id="tab-history">
    <batch-clearing-history-list ng-if="\$ctrl.displayMode === 'CLEARING_RESULT'"></batch-clearing-history-list>
  </div>

  <div id="tab-disposition" permissions='CHK_OUTGOING_DISPOSITION_READ'>
    <dispositions ng-if="\$ctrl.displayMode === 'DISPOSITIONS'"></dispositions>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/batch-clearing-page/batch-clearing-page.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;